import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson21: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson20"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Cross vs Isolated Margin
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson22"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[4.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Nowadays, numerous exchanges provide leverage trading options in
            various forms. A key distinction is the type of margins employed by
            these exchanges, with cross and isolated margins being the most
            common.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Before diving into the different margin types, let's quickly review
            what margin is. Suppose Jack uses $1000 of his own money as
            collateral for a leveraged position; this is known as margin. With
            leverage, the position size can be greater than the margin itself.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What Is Cross Margin?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>{`Cross margin is the most widely-used margin mode across exchanges. In this mode, your entire account balance serves as collateral for all open positions. One advantage of cross margin is that the profit and loss (P&L) from one position can be used to support another position nearing liquidation. This can also apply to unrealized P&L, depending on the platform.`}</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Although cross margin is simple and convenient, it carries
                  risks. Traders using cross margin may lose their entire
                  account balance in the event of liquidation. In the previous
                  example, Jack would lose his entire $1000. The only way to
                  avoid liquidation is by adding more funds to the account.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[45.63rem] object-cover"
            alt=""
            src="/i91@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What Is Isolated Margin?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  With Isolated Margin mode, you assign margin to a specific
                  position or trading pair. As shown in the screenshot below,
                  the platform requires you to transfer funds into the isolated
                  margin before trading.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  This margin mode enables you to control risk for a particular
                  pair or position by selecting the amount of margin allocated
                  to it. In worst-case scenarios, this approach is beneficial
                  since only the funds assigned to the position can be
                  liquidated.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[45.63rem] object-cover"
            alt=""
            src="/i92@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Which One Is Better?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>{`There isn't a clear-cut answer to this question. Your choice between the two largely depends on your risk management approach. Remember that a stop loss, whether applied to a cross margin or isolated margin position, can still limit a position's losses to a pre-determined amount. In simpler terms, with appropriate risk management, liquidation can be entirely avoided, making cross margin not as risky as it might seem. Instead, it becomes a valuable tool that enables you to use the P&L from a winning position to salvage a losing one – quite advantageous, isn't it? Cross margin might be more appealing if you prefer to partially hedge positions or engage in pair trades (e.g., shorting Bitcoin while longing AVAX). If you primarily take single trades, you might lean towards using isolated margin. Ultimately, it's more about personal preference than one being superior to the other.`}</span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300" 
      href="/lesson22">
        <div className="w-full">
        <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.9rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson21;
